<template>
    <div class="successful_medical_case">
        <div class="smc_header">
            <div class="smc_disease_tag">
                <span class="dot"></span>
                <span>患者的病种</span>
            </div>
            <div class="smc_title">{{ diseaseName || '成功病案' }}</div>
            <div class="smc_desc">同病种成功病案展示 · 以下均为慈脉中医治愈的真实案例，病案信息已严格脱敏</div>
        </div>
        <div class="smc_body">
            <div class="smc_list">
                <div v-for="(item, index) in list" :key="index" class="smc_card" @click="viewDetail(item)">
                    <div class="smc_card_header">
                        <div class="smc_avatar">
                            <!-- <img v-if="item.pictureUrl" :src="getFirstPicture(item.pictureUrl)" /> -->
                            <span>{{ item.patientName ? item.patientName.charAt(0) : '医' }}</span>
                        </div>
                        <div class="smc_info">
                            <div class="smc_name">{{ item.patientName }}</div>
                            <div class="smc_sub">{{ item.genderName }} · {{ item.patientAge }}岁</div>
                        </div>
                        <div class="smc_tag">
                            <Icon type="md-checkmark-circle" />
                            <span>已治愈</span>
                        </div>
                    </div>
                    <div class="smc_card_content">
                        <div class="smc_card_stats">
                            <div class="smc_stat">
                                <Icon type="md-medkit" />
                                <div class="smc_stat_info">
                                    <div class="smc_stat_label">病种</div>
                                    <div class="smc_stat_value">{{ item.diseaseName }}</div>
                                </div>
                            </div>
                            <div class="smc_stat">
                                <Icon type="md-people" />
                                <div class="smc_stat_info">
                                    <div class="smc_stat_label">看诊次数</div>
                                    <div class="smc_stat_value">共{{ item.visitTimes || 0 }}次</div>
                                </div>
                            </div>
                            <div class="smc_stat">
                                <Icon type="md-medical" />
                                <div class="smc_stat_info">
                                    <div class="smc_stat_label">服药贴数</div>
                                    <div class="smc_stat_value">{{ item.cureDay || 0 }}贴</div>
                                </div>
                            </div>
                            <div class="smc_stat">
                                <Icon type="md-time" />
                                <div class="smc_stat_info">
                                    <div class="smc_stat_label">诊疗周期</div>
                                    <div class="smc_stat_value">{{ item.cureCycle || 0 }}天</div>
                                </div>
                            </div>
                        </div>
                        <div class="smc_card_remark" v-if="item.remarks">
                            <div class="smc_remark_title">
                                <span class="dot"></span>
                                治愈情况
                            </div>
                            <div class="smc_remark_content">{{ item.remarks }}</div>
                        </div>
                        <div class="smc_card_footer">
                            <span class="smc_view_detail">查看详情</span>
                            <Icon type="md-arrow-forward" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="list.length === 0 && !loading" class="smc_empty">
                <empty />
            </div>
            <div v-if="hasMore && list.length > 0" class="smc_load_more" @click="loadMore">
                <Icon type="ios-arrow-down" />
                <span>加载更多成功病案</span>
            </div>
            <div v-if="!hasMore && list.length > 0" class="smc_tip"><i></i><span>已展示此病种全部成功病案</span><i></i></div>

            <!-- 视频展示 -->
            <div class="smc_video_section">
                <div class="smc_section_title">
                    <span class="dot"></span>
                    成功病案视频
                </div>
                <div class="smc_video_list">
                    <div v-for="(item, index) in videoList" :key="index" class="smc_video_card"
                        @click="playVideo(item)">
                        <div class="smc_video_cover">
                            <video :src="cleanVideoUrl(item.string3)" muted preload="metadata" playsinline
                                class="smc_video_preview"></video>
                            <div class="smc_video_play_overlay">
                                <!-- <Icon type="ios-play" /> -->
                                 <Icon type="md-arrow-dropright-circle" />
                            </div>
                            <div class="smc_video_duration">{{ item.string5 }}</div>
                        </div>
                        <div class="smc_video_title">{{ item.string4 }}</div>
                    </div>
                </div>
                <empty v-if="videoList.length === 0" />
            </div>
        </div>

        <!-- 视频播放弹窗 -->
        <Modal v-model="videoVisible" :width="'80%'" footer-hide :mask-closable="true" class="smc_video_modal"
            :title="currentVideo?.string4 || '视频播放'">
            <div class="smc_video_player_wrap">
                <video v-if="videoVisible" ref="videoPlayer" :src="cleanVideoUrl(currentVideo?.string3)" controls
                    autoplay class="smc_video_player" playsinline></video>
            </div>
        </Modal>

        <Modal v-model="detailVisible" :width="isPad ? '90%' : '700px'" footer-hide
            :title="`病案详情 · ${currentDetail?.diseaseName}`" :mask-closable="false">
            <div v-if="currentDetail" class="smc_detail">
                <div class="smc_detail_patient">
                    <div class="smc_avatar">
                        <span>{{ currentDetail.patientName ? currentDetail.patientName.charAt(0) : '医' }}</span>
                    </div>
                    <div class="smc_info">
                        <div class="smc_name">{{ currentDetail.patientName }}</div>
                        <div class="smc_sub">{{ currentDetail.genderName }} · {{ currentDetail.patientAge }}岁</div>
                    </div>
                    <div class="smc_tag">
                        <Icon type="md-checkmark-circle" />
                        <span>已治愈</span>
                    </div>
                </div>

                <div class="smc_detail_section">
                    <div class="smc_section_title">
                        <span class="dot"></span>
                        基本信息
                    </div>
                    <div class="smc_info_grid">
                        <div class="smc_info_item">
                            <div class="smc_info_label">性别 · 年龄</div>
                            <div class="smc_info_value">{{ currentDetail.genderName }} · {{ currentDetail.patientAge }}岁
                            </div>
                        </div>
                        <div class="smc_info_item">
                            <div class="smc_info_label">病种</div>
                            <div class="smc_info_value">{{ currentDetail.diseaseName }}</div>
                        </div>
                        <div class="smc_info_item">
                            <div class="smc_info_label">首次看诊</div>
                            <div class="smc_info_value">{{ currentDetail.startDate }}</div>
                        </div>
                        <div class="smc_info_item">
                            <div class="smc_info_label">末次看诊</div>
                            <div class="smc_info_value">{{ currentDetail.endDate }}</div>
                        </div>
                    </div>
                </div>

                <div class="smc_detail_section" v-if="currentDetail.remarks">
                    <div class="smc_section_title">
                        <span class="dot"></span>
                        治愈情况
                    </div>
                    <div class="smc_detail_remark">
                        <div class="smc_remark_icon">
                            <Icon type="md-checkmark-circle-outline" />
                        </div>
                        <div class="smc_remark_text">{{ currentDetail.remarks }}</div>
                    </div>
                </div>

                <div class="smc_detail_stats">
                    <div class="smc_detail_stat">
                        <div class="smc_detail_stat_num">{{ currentDetail.visitTimes || 0 }}</div>
                        <div class="smc_detail_stat_label">看诊次数</div>
                    </div>
                    <div class="smc_detail_stat">
                        <div class="smc_detail_stat_num">{{ currentDetail.cureDay || 0 }}</div>
                        <div class="smc_detail_stat_label">服药贴数</div>
                    </div>
                    <div class="smc_detail_stat">
                        <div class="smc_detail_stat_num">{{ currentDetail.cureCycle || 0 }}</div>
                        <div class="smc_detail_stat_label">诊疗周期（天）</div>
                    </div>
                </div>

                <div class="smc_detail_section" v-if="currentDetail.pictureUrl">
                    <div class="smc_section_title">
                        <span class="dot"></span>
                        患者反馈
                    </div>
                    <div class="smc_detail_images">
                        <img v-for="(pic, i) in getPictures(currentDetail.pictureUrl)" :key="i" :src="pic"
                            class="smc_detail_img" @click="previewImage(pic)" />
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: {
        info: {
            type: Object,
            default: () => {
                return {};
            }
        },
        isPad: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            list: [],
            pageSize: 6,
            pageIndex: 1,
            total: 0,
            hasMore: true,
            diseaseName: '',
            detailVisible: false,
            currentDetail: null,
            videoVisible: false,
            currentVideo: null
        };
    },
    computed: {
        ...mapGetters([
            "dicts",
        ]),
        Patient_Health_Video() {
            return this.dicts["Patient_Health_Video"] || [];
        },
        videoList() {
            const diseaseId = this.info.diseaseId;
            return this.Patient_Health_Video.filter(v => v.string1 === String(diseaseId));
        }
    },
    methods: {
        cleanVideoUrl(url) {
            if (!url) return '';
            return url.trim().replace(/^`+|`+$/g, '').trim();
        },
        playVideo(item) {
            this.currentVideo = item;
            this.videoVisible = true;
        },
        getFirstPicture(urlStr) {
            if (!urlStr) return '';
            const urls = urlStr.split(',');
            return urls[0] || '';
        },
        getPictures(urlStr) {
            if (!urlStr) return [];
            return urlStr.split(',').filter(u => u).map(u => this.cloudPic + '/backups/' + u);
        },
        previewImage(url) {
            window.open(url, '_blank');
        },
        viewDetail(item) {
            this.currentDetail = item;
            this.detailVisible = true;
        },
        loadMore() {
            if (this.loading) return;
            this.pageIndex++;
            this.getData();
        },
        getData() {
            if (this.loading) return;
            this.loading = true;
            this.api2('showEnterprisePatientHealthRecord', {
                diseaseId: this.info.diseaseId,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex
            }).then(res => {
                if (res) {
                    this.total = res.total || 0;
                    const newList = res.result || [];
                    if (this.pageIndex === 1) {
                        this.list = newList;
                    } else {
                        this.list = this.list.concat(newList);
                    }
                    this.hasMore = this.list.length < this.total;
                    if (newList.length > 0 && !this.diseaseName) {
                        this.diseaseName = newList[0].diseaseName;
                    }
                }
                this.loading = false;
            }).catch(e => {
                console.error('获取成功病案失败:', e);
                this.loading = false;
            });
        },
        init() {
            this.pageIndex = 1;
            this.list = [];
            this.diseaseName = '';
            this.getData();
        }
    },
    created() {
        this.init();
        this.$store.dispatch("getWideUseList", {
            key: "Patient_Health_Video",
            type: "saas",
        });
    },
    watch: {
        info: {
            handler(newVal, oldVal) {
                if (newVal.patientCode !== oldVal.patientCode) {
                    this.init();
                }
            },
            deep: true
        },
    }
};
</script>

<style lang="scss" scoped>
.successful_medical_case {
    height: 100%;
    overflow-y: auto;
}

.smc_header {
    text-align: center;
    margin-bottom: 15px;
}

.smc_disease_tag {
    display: inline-flex;
    align-items: center;
    padding: 6px 16px;
    background: #f0e7e5;
    border-radius: 20px;
    color: #692d23;
    font-size: 13px;
    margin-bottom: 5px;
}

.smc_disease_tag .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #D4A574;
    margin-right: 8px;
}

.smc_title {
    font-size: 28px;
    font-weight: bold;
    color: #6B4423;
    margin-bottom: 5px;
    letter-spacing: 2px;
}

.smc_desc {
    font-size: 13px;
    color: #A08B70;
    line-height: 1.6;
}

.smc_body {
    position: relative;
}

.smc_list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
}

.smc_card {
    overflow: hidden;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #e2d6d5;
    box-shadow: 0 2px 8px rgba(139, 94, 60, 0.06);
}

.smc_card:hover {
    box-shadow: 0 6px 20px rgba(139, 94, 60, 0.12);
    transform: translateY(-3px);
}

.smc_card_header {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    background: #f6eeec;
}

.smc_avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #692d23 0%, #A67B5B 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    color: #fff;
    font-size: 17px;
    font-weight: bold;
    box-shadow: 0 2px 6px rgba(139, 94, 60, 0.25);
}

.smc_avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.smc_info {
    flex: 1;
    margin-left: 12px;
}

.smc_name {
    font-size: 15px;
    font-weight: bold;
    color: #5D4037;
    margin-bottom: 0px;
}

.smc_sub {
    font-size: 12px;
    color: #A08B70;
}

.smc_tag {
    display: flex;
    align-items: center;
    padding: 4px 10px;
    background: #fffce0;
    border-radius: 12px;
    color: #8a7015;
    font-size: 11px;
    font-weight: 500;
}

.smc_tag .ivu-icon,
.smc_tag .iconfont {
    margin-right: 3px;
    font-size: 12px;
}

.smc_card_content {
    padding: 15px 15px 10px;
}

.smc_card_stats {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 16px;
}

.smc_stat {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    background: #f6eeec;
    border-radius: 8px;
    border: 1px solid #f6eeec;
}

.smc_stat .ivu-icon,
.smc_stat .iconfont {
    font-size: 16px;
    color: #A67B5B;
    margin-right: 8px;
    flex-shrink: 0;
    padding: 5px;
    background: #fff;
    border-radius: 50%;
}

.smc_stat_info {
    flex: 1;
    min-width: 0;
}

.smc_stat_label {
    font-size: 11px;
    color: #A08B70;
    margin-bottom: 2px;
}

.smc_stat_value {
    font-size: 13px;
    color: #5D4037;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.smc_card_remark {
    background: #fafafa;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 12px;
    border-left: 3px solid #692d23;
    height: 108px;
}

.smc_remark_title {
    font-size: 12px;
    color: #6B4423;
    font-weight: 600;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.smc_remark_title .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #692d23;
    margin-right: 8px;
}

.smc_remark_content {
    font-size: 12px;
    color: #8B7355;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.smc_card_footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 8px;
    border-top: 1px dashed #E8D5B7;
    color: #692d23;
    font-size: 13px;
    font-weight: 500;
}

.smc_card_footer .ivu-icon,
.smc_card_footer .iconfont {
    margin-left: 4px;
    font-size: 14px;
}

.smc_view_detail {
    cursor: pointer;
}

.smc_view_detail:hover {
    text-decoration: underline;
}

.smc_empty {
    padding: 60px 0;
    text-align: center;
}

.smc_load_more {
    text-align: center;
    padding: 14px 30px;
    margin: 20px auto 0;
    background: #F5E6D3;
    border-radius: 24px;
    color: #6B4423;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    display: block;
    width: fit-content;

    .ivu-icon {
        font-size: 18px;
        margin-right: 5px;
    }
}

.smc_load_more:hover {
    background: #E8D4B8;
    transform: scale(1.02);
}

.smc_detail {
    padding: 10px 0;
}

.smc_detail_header {
    margin-bottom: 20px;
}

.smc_detail_title {
    font-size: 20px;
    font-weight: bold;
    color: #6B4423;
}

.smc_detail_patient {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background: #FAF6F0;
    border-radius: 10px;
    margin-bottom: 24px;
    border: 1px solid #F0E5D5;
}

.smc_detail_section {
    margin-bottom: 24px;
}

.smc_section_title {
    font-size: 16px;
    font-weight: bold;
    color: #6B4423;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
    margin-bottom: 12px;
}

.smc_section_title .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #692d23;
    margin-right: 10px;
}

.smc_info_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
}

.smc_info_item {
    padding: 10px 14px;
    background: #FFFBF5;
    border: 1px solid #F0E5D5;
    border-radius: 8px;
}

.smc_info_label {
    font-size: 13px;
    color: #A08B70;
    margin-bottom: 6px;
}

.smc_info_value {
    font-size: 15px;
    color: #5D4037;
    font-weight: 600;
}

.smc_detail_remark {
    display: flex;
    align-items: flex-start;
    padding: 18px;
    background: #FDF8F0;
    border-radius: 10px;
    margin-bottom: 24px;
    border-left: 3px solid #692d23;
}

.smc_remark_icon {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: #5D4037;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
    margin-right: 14px;
    font-size: 22px;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15);
}

.smc_remark_text {
    flex: 1;
    font-size: 14px;
    color: #6B5540;
    line-height: 1.8;
}

.smc_detail_stats {
    display: flex;
    justify-content: space-around;
    padding: 15px 0;
    background: #FAF6F0;
    border-radius: 10px;
    margin-bottom: 24px;
    border: 1px solid #F0E5D5;
}

.smc_detail_stat {
    text-align: center;
    flex: 1;
    position: relative;

    &+.smc_detail_stat {
        &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(0, -50%);
            width: 1px;
            height: 30px;
            background: #F0E5D5;
        }

    }
}

.smc_detail_stat_num {
    font-size: 28px;
    height: 35px;
    line-height: 35px;
    font-weight: bold;
    color: #692d23;
}

.smc_detail_stat_label {
    font-size: 13px;
    color: #A08B70;
}

.smc_detail_images {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.smc_detail_img {
    min-width: 100%;
    cursor: pointer;
}

.smc_tip {
    font-size: 12px;
    color: #A08B70;
    margin: 30px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        margin: 0 12px;
    }

    i {
        border-bottom: 1px solid #ccc;
        width: 100px;
        height: 1px;
    }
}

.smc_video_section {
    margin-top: 30px;
}

.smc_video_list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
}

.smc_video_card {
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e2d6d5;
    box-shadow: 0 2px 8px rgba(139, 94, 60, 0.06);
    background: #fff;
}

.smc_video_card:hover {
    box-shadow: 0 6px 20px rgba(139, 94, 60, 0.15);
    transform: translateY(-3px);
}

.smc_video_cover {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    background: #000;
    overflow: hidden;
}

.smc_video_preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
}

.smc_video_play_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    transition: background 0.3s;

    .ivu-icon,
    .iconfont {
        font-size: 52px;
        color: #692d23;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
        transition: transform 0.3s;
    }
}

.smc_video_card:hover .smc_video_play_overlay {
    background: rgba(0, 0, 0, 0.15);

    .ivu-icon,
    .iconfont {
        transform: scale(1.15);
    }
}

.smc_video_duration {
    position: absolute;
    bottom: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: monospace;
}

.smc_video_title {
    padding: 10px 12px;
    font-size: 14px;
    color: #5D4037;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 1200px) {
    .smc_list {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .smc_list {
        grid-template-columns: 1fr;
    }
}
</style>

<style lang="scss">
/* Modal 内容被 teleport 到 document 层级，需非 scoped 样式 */
.smc_video_modal .smc_video_player_wrap {
    background: #000;
    border-radius: 8px;
    overflow: hidden;
}

.smc_video_modal .smc_video_player {
    width: 100%;
    max-height: 75vh;
    display: block;
}
</style>
